export default {
   
    enviado: {
        estado:true
    }
}